<template>
  <div class="tcla-anchors">
    <div class="tcla-panel">
      <h3 class="tcla-panel__title">⚓ تحلیل تنوع انکرتکست</h3>
      <div v-if="anchorAnalysis.length === 0" class="tcla-empty">لینک ورودی‌ای برای تحلیل یافت نشد</div>
      <div v-for="a in anchorAnalysis" :key="a.url" class="tcla-anchor-card">
        <div class="tcla-anchor-card__head">
          <div>
            <strong>{{ a.title }}</strong>
            <span v-if="a.overOptimized" class="tcla-tag tcla-tag--err">بیش‌بهینه‌سازی</span>
          </div>
          <span class="tcla-score-pill" :class="scoreClass(a.diversityScore)">{{ a.diversityScore }}%</span>
        </div>

        <div class="tcla-anchor-card__stats">
          <span>پرتکرارترین: <strong>{{ a.topAnchor }}</strong> ({{ a.topAnchorRatio }}%)</span>
          <span>·</span>
          <span>کل لینک‌ها: {{ a.totalAnchors }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TCLAAnchors',
  props: {
    anchorAnalysis: { type: Array, default: () => [] }
  },
  methods: {
    scoreClass(score) {
      if (score >= 70) return 'tcla-score--good';
      if (score >= 40) return 'tcla-score--mid';
      return 'tcla-score--bad';
    }
  }
};
</script>

<style scoped>
.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
}

.tcla-panel__title { font-size: 0.95rem; font-weight: 700; margin: 0 0 14px 0; }
.tcla-empty { text-align: center; padding: 20px; color: #9ca3af; }

.tcla-anchor-card {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 14px;
  background: #f9fafb;
  margin-bottom: 12px;
}

.tcla-anchor-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.tcla-anchor-card__stats {
  font-size: 0.8rem;
  color: #6b7280;
  display: flex;
  gap: 8px;
  align-items: center;
}

.tcla-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  margin-left: 6px;
}
.tcla-tag--err { background: #fee2e2; color: #ef4444; }

.tcla-score-pill {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.75rem;
}
.tcla-score--good { background: #d1fae5; color: #16a34a; }
.tcla-score--mid { background: #fef3c7; color: #d97706; }
.tcla-score--bad { background: #fee2e2; color: #ef4444; }
</style>
